import { call, put } from 'redux-saga/effects';
import { setGenericParameters, savedGenericParameter } from '../../ducks/genericParameters';
import {
    requestLoadGenericParameters,
    requestSaveGenericParameter,
} from '../requests/genericParameters';

export function* handleLoadGenericParameters() {
    try {
        const response = yield call(requestLoadGenericParameters);
        yield put(setGenericParameters(response.data));
    } catch (error) {
        console.log(error);
    }
}

export function* handleSaveGenericParameter(action) {
    try {
        const response = yield call(requestSaveGenericParameter, action.parameter);
        yield put(savedGenericParameter(response.data));
    } catch (error) {
        console.log(error);
    }
}
